export const BASE_URL = import.meta.env.VITE_DJANGO_BACKEND_URL
export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL
export const SERVER_URL = import.meta.env.VITE_DJANGO_BACKEND_URL.replace(
  '/api',
  ''
)
export const THIRD_PARTY_SWAGGER_URL =
  `${BASE_URL.replace(/\/?$/, '')}/v1/swagger/`
